export const institucionState = {
    listado: [],
    isLoading: false,
    message: '',
    severity: '',
}